import { createContext } from "react";
import { User } from "../../@lib/services/api/auth";

export type AuthSession = {
  user?: User | null;
  loginUser: (email: string, password: string) => void;
  logoutUser: () => void;
  resetPasswordToken: (token: string) => void;
  passwordToken: String;
};

const authSessionContext = createContext<AuthSession>({
  user: null,
  passwordToken: "",
  loginUser: () => void 0,
  logoutUser: () => void 0,
  resetPasswordToken: () => void "",
});

export default authSessionContext;
